"use client";

import { Provider } from "react-redux";
import { store } from "../redux/store";
import { useEffect } from "react";
import {
  hydrateSearchHistory,
  readStoredSearchHistory,
} from "@/redux/slices/search.slice";

export default function StoreProvider({ children }) {
  useEffect(() => {
    store.dispatch(hydrateSearchHistory(readStoredSearchHistory()));

    // Custom state restoration after render to prevent white screen
    if (typeof window !== "undefined") {
      const restoreAuthState = () => {
        try {
          // Get auth data from cookies without blocking render
          const authCookie = document.cookie
            .split("; ")
            .find((row) => row.startsWith("persist:auth="));

          if (authCookie) {
            const authData = JSON.parse(
              decodeURIComponent(authCookie.split("=")[1])
            );
            if (authData && (authData.user || authData.token)) {
              // Dispatch action to restore auth state non-blocking
              store.dispatch({
                type: "auth/restoreState",
                payload: {
                  user: authData.user ? JSON.parse(authData.user) : null,
                  token: authData.token ? JSON.parse(authData.token) : null,
                  isAuthenticated: authData.isAuthenticated
                    ? JSON.parse(authData.isAuthenticated)
                    : false,
                },
              });
            }
          }
        } catch (error) {
          console.warn("Failed to restore auth state:", error);
        }
      };

      // Restore state after initial render
      setTimeout(restoreAuthState, 0);
    }
  }, []);

  return <Provider store={store}>{children}</Provider>;
}
